import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Button,
  Table,
  Badge,
  Modal,
  Form,
  Tabs,
  Tab,
} from "react-bootstrap";
import {
  FaAd,
  FaCheck,
  FaTimes,
  FaEye,
  FaInfoCircle,
  FaRedo,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const AdsManagement = () => {
  const [pendingAds, setPendingAds] = useState([]);
  const [approvedAds, setApprovedAds] = useState([]);
  const [rejectedAds, setRejectedAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [selectedAd, setSelectedAd] = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const [activeTab, setActiveTab] = useState("pending");
  const [counts, setCounts] = useState({
    pending: 0,
    approved: 0,
    rejected: 0,
  });
  const navigate = useNavigate();

  // Active Popup settings state
  const [popupActive, setPopupActive] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupImageUrl, setPopupImageUrl] = useState("");
  const [popupLinkUrl, setPopupLinkUrl] = useState("");
  const [popupPhone, setPopupPhone] = useState("");
  const [isSavingPopup, setIsSavingPopup] = useState(false);
  const [isUploadingPopupImage, setIsUploadingPopupImage] = useState(false);

  useEffect(() => {
    console.log("AdsManagement component mounted");
    fetchAllAds();
    fetchPopupSettings();
  }, []);

  const fetchPopupSettings = async () => {
    const bases = Array.from(
      new Set(
        [
          process.env.REACT_APP_API_BASE_URL,
          "http://10.199.86.106:3000",
          "http://localhost:3000",
          "https://quvikmetech-backend-1.onrender.com",
          "https://api.quvikme.com"
        ].filter(Boolean)
      )
    );

    for (const base of bases) {
      try {
        const response = await fetch(`${base}/api/ads/active-popup`);
        if (response.ok) {
          const data = await response.json();
          if (data) {
            setPopupActive(!!data.isActive);
            setPopupTitle(data.title || "");
            setPopupImageUrl(data.imageUrl || "");
            setPopupLinkUrl(data.linkUrl || "");
            setPopupPhone(data.phone || "");
          }
          break;
        }
      } catch (e) {
        console.error("Error fetching popup settings from:", base, e);
      }
    }
  };

  const savePopupSettings = async () => {
    setIsSavingPopup(true);
    const bases = Array.from(
      new Set(
        [
          process.env.REACT_APP_API_BASE_URL,
          "http://10.199.86.106:3000",
          "http://localhost:3000",
          "https://quvikmetech-backend-1.onrender.com",
          "https://api.quvikme.com"
        ].filter(Boolean)
      )
    );

    const adminToken = localStorage.getItem("adminToken") || sessionStorage.getItem("adminToken");
    const payload = {
      isActive: popupActive,
      title: popupTitle,
      imageUrl: popupImageUrl,
      linkUrl: popupLinkUrl,
      phone: popupPhone
    };

    let success = false;
    for (const base of bases) {
      try {
        const response = await fetch(`${base}/api/ads/active-popup`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${adminToken}`
          },
          body: JSON.stringify(payload)
        });

        if (response.ok) {
          success = true;
          alert("Popup settings saved successfully!");
          break;
        }
      } catch (e) {
        console.error("Error saving popup settings to:", base, e);
      }
    }

    if (!success) {
      alert("Failed to save popup settings. Please try again.");
    }
    setIsSavingPopup(false);
  };

  const handlePopupImageUpload = async (file) => {
    setIsUploadingPopupImage(true);
    const bases = Array.from(
      new Set(
        [
          process.env.REACT_APP_API_BASE_URL,
          "http://10.199.86.106:3000",
          "http://localhost:3000",
          "https://quvikmetech-backend-1.onrender.com",
          "https://api.quvikme.com"
        ].filter(Boolean)
      )
    );

    const adminToken = localStorage.getItem("adminToken") || sessionStorage.getItem("adminToken");
    const formData = new FormData();
    formData.append("file", file);

    let success = false;
    for (const base of bases) {
      try {
        const response = await fetch(`${base}/api/upload`, {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${adminToken}`
          },
          body: formData
        });

        if (response.ok) {
          const data = await response.json();
          if (data && data.url) {
            setPopupImageUrl(data.url);
            success = true;
            alert("Image uploaded successfully!");
          }
          break;
        }
      } catch (e) {
        console.error("Error uploading image to:", base, e);
      }
    }

    if (!success) {
      alert("Failed to upload image. Please try again.");
    }
    setIsUploadingPopupImage(false);
  };

  const handleSetAsPopup = async (ad) => {
    const bases = Array.from(
      new Set(
        [
          process.env.REACT_APP_API_BASE_URL,
          "http://10.199.86.106:3000",
          "http://localhost:3000",
          "https://quvikmetech-backend-1.onrender.com",
          "https://api.quvikme.com"
        ].filter(Boolean)
      )
    );

    const adminToken = localStorage.getItem("adminToken") || sessionStorage.getItem("adminToken");
    const payload = {
      isActive: true,
      title: ad.title || "",
      imageUrl: ad.adImageUrl || ad.imageUrl || "",
      linkUrl: ad.cta || "",
      phone: ""
    };

    let success = false;
    for (const base of bases) {
      try {
        const response = await fetch(`${base}/api/ads/active-popup`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${adminToken}`
          },
          body: JSON.stringify(payload)
        });

        if (response.ok) {
          success = true;
          alert(`Dashboard popup set successfully to ad: "${ad.title}"!`);
          setPopupActive(true);
          setPopupTitle(ad.title || "");
          setPopupImageUrl(ad.adImageUrl || ad.imageUrl || "");
          setPopupLinkUrl(ad.cta || "");
          setPopupPhone("");
          break;
        }
      } catch (e) {
        console.error("Error setting ad as popup:", base, e);
      }
    }

    if (!success) {
      alert("Failed to set ad as dashboard popup.");
    }
  };

  const fetchAllAds = async () => {
    try {
      setLoading(true);
      setError(null);
      console.log("Fetching all ads...");

      // Backend is on port 3000, frontend is on port 5002
      const bases = Array.from(
        new Set(
          [
            process.env.REACT_APP_API_BASE_URL, // Put this last as fallback
          ].filter(Boolean)
        )
      );

      console.log("API bases to try:", bases);

      let pendingData = null;
      let approvedData = null;
      let rejectedData = null;
      let lastErr = null;

      // Fetch all types of ads
      for (const base of bases) {
        try {
          const adminToken =
            localStorage.getItem("adminToken") ||
            sessionStorage.getItem("adminToken");
          const headers = {
            "Content-Type": "application/json",
          };

          if (adminToken) {
            headers["Authorization"] = `Bearer ${adminToken}`;
          }

          // Try to fetch each type of ad, but don't fail if one fails
          let pendingSuccess = false;
          let approvedSuccess = false;
          let rejectedSuccess = false;

          // Fetch pending ads
          try {
            console.log(
              `Trying to fetch pending ads from: ${base}/api/ads/pending`
            );
            const pendingResponse = await fetch(`${base}/api/ads/pending`, {
              headers,
            });
            if (pendingResponse.ok) {
              pendingData = await pendingResponse.json();
              pendingSuccess = true;
              console.log("✅ Successfully fetched pending ads from:", base);
            } else {
              console.warn(
                `Pending ads fetch failed with status ${pendingResponse.status} from ${base}`
              );
            }
          } catch (e) {
            console.error("Error fetching pending ads from base:", base, e);
          }

          // Fetch approved ads
          try {
            console.log(
              `Trying to fetch approved ads from: ${base}/api/ads/approved`
            );
            const approvedResponse = await fetch(`${base}/api/ads/approved`, {
              headers,
            });
            if (approvedResponse.ok) {
              approvedData = await approvedResponse.json();
              approvedSuccess = true;
              console.log("✅ Successfully fetched approved ads from:", base);
            } else {
              console.warn(
                `Approved ads fetch failed with status ${approvedResponse.status} from ${base}`
              );
            }
          } catch (e) {
            console.error("Error fetching approved ads from base:", base, e);
          }

          // Fetch rejected ads
          try {
            console.log(
              `Trying to fetch rejected ads from: ${base}/api/ads/rejected`
            );
            const rejectedResponse = await fetch(`${base}/api/ads/rejected`, {
              headers,
            });
            if (rejectedResponse.ok) {
              rejectedData = await rejectedResponse.json();
              rejectedSuccess = true;
              console.log("✅ Successfully fetched rejected ads from:", base);
            } else {
              console.warn(
                `Rejected ads fetch failed with status ${rejectedResponse.status} from ${base}`
              );
            }
          } catch (e) {
            console.error("Error fetching rejected ads from base:", base, e);
          }

          // If we successfully fetched at least one endpoint, break
          if (pendingSuccess || approvedSuccess || rejectedSuccess) {
            console.log("✅ Successfully connected to backend at:", base);
            break;
          }
        } catch (e) {
          lastErr = e;
          console.error("Error fetching from base:", base, e);
          continue;
        }
      }

      // Set data for whatever we were able to fetch, use empty arrays for failed requests
      setPendingAds(pendingData?.ads || []);
      setApprovedAds(approvedData?.ads || []);
      setRejectedAds(rejectedData?.ads || []);

      // Update counts
      setCounts({
        pending: (pendingData?.ads || []).length,
        approved: (approvedData?.ads || []).length,
        rejected: (rejectedData?.ads || []).length,
      });

      setLoading(false);
    } catch (err) {
      console.error("Error fetching ads:", err);
      setError("Failed to load ads: " + err.message);
      setLoading(false);
    }
  };

  const fetchPendingAds = async () => {
    try {
      setLoading(true);
      setError(null);
      console.log("Fetching pending ads...");

      // Backend is on port 3000
      const bases = Array.from(
        new Set([process.env.REACT_APP_API_BASE_URL].filter(Boolean))
      );

      console.log("API bases to try:", bases);

      let adsData = null;
      let lastErr = null;

      for (const base of bases) {
        try {
          console.log(`Trying to fetch from: ${base}/api/ads/pending`);

          const adminToken =
            localStorage.getItem("adminToken") ||
            sessionStorage.getItem("adminToken");
          const headers = {
            "Content-Type": "application/json",
          };

          if (adminToken) {
            headers["Authorization"] = `Bearer ${adminToken}`;
          }

          console.log("Headers:", headers);

          const response = await fetch(`${base}/api/ads/pending`, { headers });

          console.log(`Response status: ${response.status}`);

          if (!response.ok) {
            const errorText = await response.text();
            console.error(`Error response body: ${errorText}`);
            lastErr = new Error(
              `Failed to fetch from ${base} - Status: ${response.status}, Message: ${errorText}`
            );
            console.error(lastErr.message);
            continue;
          }

          adsData = await response.json();
          console.log("Successfully fetched ads data:", adsData);
          break;
        } catch (e) {
          lastErr = e;
          console.error("Error fetching from base:", base, e);
          continue;
        }
      }

      if (!adsData) throw lastErr || new Error("Failed to load pending ads");

      setPendingAds(adsData.ads || []);
      setCounts((prev) => ({ ...prev, pending: (adsData.ads || []).length }));
      setLoading(false);
    } catch (err) {
      console.error("Error fetching pending ads:", err);
      setError("Failed to load pending ads: " + err.message);
      setLoading(false);
    }
  };

  const handleApproveAd = async (adId) => {
    try {
      // Backend is on port 3000
      const bases = Array.from(
        new Set([process.env.REACT_APP_API_BASE_URL].filter(Boolean))
      );

      let success = false;
      let lastErr = null;

      for (const base of bases) {
        try {
          const adminToken =
            localStorage.getItem("adminToken") ||
            sessionStorage.getItem("adminToken");
          const headers = {
            "Content-Type": "application/json",
          };

          if (adminToken) {
            headers["Authorization"] = `Bearer ${adminToken}`;
          }

          console.log(
            `Approving ad ${adId} via: ${base}/api/ads/${adId}/approve`
          );
          const response = await fetch(`${base}/api/ads/${adId}/approve`, {
            method: "PUT",
            headers,
          });

          if (!response.ok) {
            const errorText = await response.text();
            lastErr = new Error(
              `Failed to approve from ${base} - Status: ${response.status}, Message: ${errorText}`
            );
            continue;
          }

          success = true;
          console.log("✅ Ad approved successfully via:", base);
          break;
        } catch (e) {
          lastErr = e;
          continue;
        }
      }

      if (!success) throw lastErr || new Error("Failed to approve ad");

      // Refresh all ads
      fetchAllAds();

      // Close modal
      setShowApproveModal(false);
      setSelectedAd(null);
    } catch (err) {
      console.error("Error approving ad:", err);
      alert("Failed to approve ad: " + err.message);
    }
  };

  const handleRejectAd = async (adId, reason) => {
    try {
      // Backend is on port 3000
      const bases = Array.from(
        new Set([process.env.REACT_APP_API_BASE_URL].filter(Boolean))
      );

      let success = false;
      let lastErr = null;

      for (const base of bases) {
        try {
          const adminToken =
            localStorage.getItem("adminToken") ||
            sessionStorage.getItem("adminToken");
          const headers = {
            "Content-Type": "application/json",
          };

          if (adminToken) {
            headers["Authorization"] = `Bearer ${adminToken}`;
          }

          console.log(
            `Rejecting ad ${adId} via: ${base}/api/ads/${adId}/reject`
          );
          const response = await fetch(`${base}/api/ads/${adId}/reject`, {
            method: "PUT",
            headers,
            body: JSON.stringify({ reason }),
          });

          if (!response.ok) {
            const errorText = await response.text();
            lastErr = new Error(
              `Failed to reject from ${base} - Status: ${response.status}, Message: ${errorText}`
            );
            continue;
          }

          success = true;
          console.log("✅ Ad rejected successfully via:", base);
          break;
        } catch (e) {
          lastErr = e;
          continue;
        }
      }

      if (!success) throw lastErr || new Error("Failed to reject ad");

      // Refresh all ads
      fetchAllAds();

      // Close modal
      setShowRejectModal(false);
      setSelectedAd(null);
      setRejectionReason("");
    } catch (err) {
      console.error("Error rejecting ad:", err);
      alert("Failed to reject ad: " + err.message);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleString();
  };

  const openApproveModal = (ad) => {
    setSelectedAd(ad);
    setShowApproveModal(true);
  };

  const openRejectModal = (ad) => {
    setSelectedAd(ad);
    setShowRejectModal(true);
  };

  const confirmApprove = () => {
    if (selectedAd) {
      handleApproveAd(selectedAd.id);
    }
  };

  const confirmReject = () => {
    if (selectedAd) {
      handleRejectAd(selectedAd.id, rejectionReason);
    }
  };

  const renderAdsTable = (ads, showActions = false, isApprovedTab = false) => {
    if (ads.length === 0) {
      return (
        <div className="text-center py-5">
          <FaAd size={48} className="text-muted mb-3" />
          <h5 className="text-muted">No ads found</h5>
          <p className="text-muted">
            {activeTab === "pending" &&
              "All ads are currently approved or rejected."}
            {activeTab === "approved" && "No ads have been approved yet."}
            {activeTab === "rejected" && "No ads have been rejected yet."}
          </p>
        </div>
      );
    }

    return (
      <div className="table-responsive">
        <Table hover className="align-middle">
          <thead className="table-light">
            <tr>
              <th>Ad Preview</th>
              <th>Title</th>
              <th>Vendor</th>
              <th>Category</th>
              <th>Status</th>
              <th>Submitted</th>
              {(showActions || isApprovedTab) && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {ads.map((ad) => (
              <tr key={ad.id}>
                <td>
                  {ad.adImageUrl ? (
                    <div
                      className="ad-preview-container"
                      style={{
                        width: "100px",
                        height: "60px",
                        overflow: "hidden",
                        borderRadius: "4px",
                      }}
                    >
                      <img
                        src={ad.adImageUrl}
                        alt="Ad Preview"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.parentElement.innerHTML =
                            '<div className="bg-secondary d-flex align-items-center justify-content-center w-100 h-100"><FaAd className="text-white" /></div>';
                        }}
                      />
                    </div>
                  ) : (
                    <div
                      className="bg-secondary d-flex align-items-center justify-content-center"
                      style={{
                        width: "100px",
                        height: "60px",
                        borderRadius: "4px",
                      }}
                    >
                      <FaAd className="text-white" />
                    </div>
                  )}
                </td>
                <td>
                  <div className="fw-semibold">{ad.title}</div>
                  <div className="small text-muted">
                    {ad.description.substring(0, 50)}...
                  </div>
                </td>
                <td>
                  <div className="fw-semibold">{ad.vendorName}</div>
                  <div className="small text-muted">ID: {ad.vendorId}</div>
                </td>
                <td>
                  <Badge bg="secondary">{ad.category}</Badge>
                </td>
                <td>
                  <Badge
                    bg={
                      ad.status === "approved"
                        ? "success"
                        : ad.status === "rejected"
                        ? "danger"
                        : "warning"
                    }
                  >
                    {ad.status}
                  </Badge>
                </td>
                <td>
                  <div className="small">{formatDate(ad.createdAt)}</div>
                </td>
                {(showActions || isApprovedTab) && (
                  <td>
                    <div className="d-flex gap-2">
                      {showActions && (
                        <>
                          <Button
                            variant="success"
                            size="sm"
                            onClick={() => openApproveModal(ad)}
                            disabled={ad.status === "approved"}
                          >
                            <FaCheck className="me-1" />
                            Approve
                          </Button>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => openRejectModal(ad)}
                            disabled={ad.status === "rejected"}
                          >
                            <FaTimes className="me-1" />
                            Reject
                          </Button>
                        </>
                      )}
                      {isApprovedTab && (
                        <Button
                          variant="warning"
                          size="sm"
                          onClick={() => handleSetAsPopup(ad)}
                        >
                          <FaAd className="me-1" />
                          Set as Dashboard Popup
                        </Button>
                      )}
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => navigate(`/vendor-info/${ad.vendorId}`)}
                      >
                        <FaEye className="me-1" />
                        View Vendor
                      </Button>
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="loading-spinner">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-message">
        <h4>Error</h4>
        <p>{error}</p>
        <Button onClick={fetchAllAds} variant="outline-primary">
          <FaRedo className="me-2" />
          Retry
        </Button>
      </div>
    );
  }

  return (
    <div className="ads-management-container p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="mb-0">
          <FaAd className="me-2" />
          Ads Management
        </h2>
        <Button variant="outline-primary" onClick={fetchAllAds}>
          <FaRedo className="me-2" />
          Refresh
        </Button>
      </div>

      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-4"
      >
        <Tab eventKey="pending" title={`Pending (${counts.pending})`}>
          <Card>
            <Card.Header className="bg-light">
              <h5 className="mb-0">
                <FaInfoCircle className="me-2" />
                Pending Ad Requests
              </h5>
            </Card.Header>
            <Card.Body>{renderAdsTable(pendingAds, true)}</Card.Body>
          </Card>
        </Tab>
        <Tab eventKey="approved" title={`Approved (${counts.approved})`}>
          <Card>
            <Card.Header className="bg-light">
              <h5 className="mb-0">
                <FaCheck className="me-2 text-success" />
                Approved Ads
              </h5>
            </Card.Header>
            <Card.Body>{renderAdsTable(approvedAds, false, true)}</Card.Body>
          </Card>
        </Tab>
        <Tab eventKey="rejected" title={`Rejected (${counts.rejected})`}>
          <Card>
            <Card.Header className="bg-light">
              <h5 className="mb-0">
                <FaTimes className="me-2 text-danger" />
                Rejected Ads
              </h5>
            </Card.Header>
            <Card.Body>{renderAdsTable(rejectedAds, false)}</Card.Body>
          </Card>
        </Tab>
        <Tab eventKey="popup-config" title="Popup Ad Config">
          <Card>
            <Card.Header className="bg-light d-flex justify-content-between align-items-center">
              <h5 className="mb-0">
                <FaAd className="me-2 text-primary" />
                Dashboard Ad Popup Settings
              </h5>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={(e) => { e.preventDefault(); savePopupSettings(); }}>
                <Form.Group className="mb-3">
                  <Form.Check 
                    type="switch"
                    id="popup-active-switch"
                    label="Enable Ad Popup Overlay on Dashboard"
                    checked={popupActive}
                    onChange={(e) => setPopupActive(e.target.checked)}
                    className="fw-bold"
                  />
                  <Form.Text className="text-muted">
                    When enabled, users will see this advertisement popup overlay upon opening the dashboard.
                  </Form.Text>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Popup Title</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="e.g. AC & APPLIANCE SERVICES"
                    value={popupTitle}
                    onChange={(e) => setPopupTitle(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Ad Poster Image</Form.Label>
                  <div className="d-flex gap-3 mb-2">
                    <Form.Control
                      type="text"
                      placeholder="Image URL (http://...)"
                      value={popupImageUrl}
                      onChange={(e) => setPopupImageUrl(e.target.value)}
                    />
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        if (e.target.files && e.target.files[0]) {
                          handlePopupImageUpload(e.target.files[0]);
                        }
                      }}
                      style={{ maxWidth: "250px" }}
                    />
                  </div>
                  {isUploadingPopupImage && (
                    <div className="small text-primary mb-2">
                      <span className="spinner-border spinner-border-sm me-2" role="status" />
                      Uploading image poster...
                    </div>
                  )}
                  {popupImageUrl && (
                    <div className="mt-2 border p-2 text-center bg-light rounded" style={{ maxWidth: "300px" }}>
                      <img src={popupImageUrl} alt="Ad Preview" style={{ maxHeight: "200px", maxWidth: "100%", objectFit: "contain" }} />
                    </div>
                  )}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Redirect/Booking Website Link</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="e.g. app.quvikme.com"
                    value={popupLinkUrl}
                    onChange={(e) => setPopupLinkUrl(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Contact Phone Numbers</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="e.g. +91 9765 910 790 | 7066 925 173"
                    value={popupPhone}
                    onChange={(e) => setPopupPhone(e.target.value)}
                  />
                </Form.Group>

                <Button 
                  variant="primary" 
                  type="submit" 
                  disabled={isSavingPopup}
                >
                  {isSavingPopup ? "Saving..." : "Save Popup Settings"}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Tab>
      </Tabs>

      {/* Approve Confirmation Modal */}
      <Modal
        show={showApproveModal}
        onHide={() => setShowApproveModal(false)}
        size="lg"
      >
        <Modal.Header closeButton className="bg-light">
          <Modal.Title>
            <FaCheck className="text-success me-2" />
            Approve Ad
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedAd && (
            <>
              <Row>
                <Col md={6}>
                  <h5>{selectedAd.title}</h5>
                  <p className="text-muted">{selectedAd.description}</p>
                  <div className="mb-3">
                    <strong>Vendor:</strong> {selectedAd.vendorName}
                  </div>
                  <div className="mb-3">
                    <strong>Category:</strong>{" "}
                    <Badge bg="secondary">{selectedAd.category}</Badge>
                  </div>
                  <div className="mb-3">
                    <strong>Submitted:</strong>{" "}
                    {formatDate(selectedAd.createdAt)}
                  </div>
                </Col>
                <Col md={6}>
                  <div
                    className="ad-preview-container border rounded p-2"
                    style={{ height: "200px", overflow: "hidden" }}
                  >
                    {selectedAd.adImageUrl ? (
                      <img
                        src={selectedAd.adImageUrl}
                        alt="Ad Preview"
                        className="w-100 h-100"
                        style={{ objectFit: "contain" }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.parentElement.innerHTML =
                            '<div className="bg-secondary d-flex align-items-center justify-content-center w-100 h-100"><FaAd size="3em" className="text-white" /></div>';
                        }}
                      />
                    ) : (
                      <div className="bg-secondary d-flex align-items-center justify-content-center w-100 h-100">
                        <FaAd size="3em" className="text-white" />
                      </div>
                    )}
                  </div>
                  <div className="text-center mt-2">
                    <small className="text-muted">Ad Preview</small>
                  </div>
                </Col>
              </Row>
              <div className="alert alert-warning mt-3">
                <strong>Warning:</strong> Are you sure you want to approve this
                ad? Once approved, it will be visible to all users.
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowApproveModal(false)}
          >
            Cancel
          </Button>
          <Button variant="success" onClick={confirmApprove}>
            <FaCheck className="me-1" />
            Approve Ad
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Reject Confirmation Modal */}
      <Modal
        show={showRejectModal}
        onHide={() => setShowRejectModal(false)}
        size="lg"
      >
        <Modal.Header closeButton className="bg-light">
          <Modal.Title>
            <FaTimes className="text-danger me-2" />
            Reject Ad
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedAd && (
            <>
              <Row>
                <Col md={6}>
                  <h5>{selectedAd.title}</h5>
                  <p className="text-muted">{selectedAd.description}</p>
                  <div className="mb-3">
                    <strong>Vendor:</strong> {selectedAd.vendorName}
                  </div>
                  <div className="mb-3">
                    <strong>Category:</strong>{" "}
                    <Badge bg="secondary">{selectedAd.category}</Badge>
                  </div>
                  <div className="mb-3">
                    <strong>Submitted:</strong>{" "}
                    {formatDate(selectedAd.createdAt)}
                  </div>
                </Col>
                <Col md={6}>
                  <div
                    className="ad-preview-container border rounded p-2"
                    style={{ height: "200px", overflow: "hidden" }}
                  >
                    {selectedAd.adImageUrl ? (
                      <img
                        src={selectedAd.adImageUrl}
                        alt="Ad Preview"
                        className="w-100 h-100"
                        style={{ objectFit: "contain" }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.parentElement.innerHTML =
                            '<div className="bg-secondary d-flex align-items-center justify-content-center w-100 h-100"><FaAd size="3em" className="text-white" /></div>';
                        }}
                      />
                    ) : (
                      <div className="bg-secondary d-flex align-items-center justify-content-center w-100 h-100">
                        <FaAd size="3em" className="text-white" />
                      </div>
                    )}
                  </div>
                  <div className="text-center mt-2">
                    <small className="text-muted">Ad Preview</small>
                  </div>
                </Col>
              </Row>
              <Form.Group className="mb-3 mt-3">
                <Form.Label>Rejection Reason (Optional)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  placeholder="Enter reason for rejection..."
                />
              </Form.Group>
              <div className="alert alert-warning">
                <strong>Warning:</strong> Are you sure you want to reject this
                ad? The vendor will be notified of the rejection.
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRejectModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmReject}>
            <FaTimes className="me-1" />
            Reject Ad
          </Button>
        </Modal.Footer>
      </Modal>

      <style>{`
        .ads-management-container {
          background-color: #f8f9fa;
          min-height: 100vh;
        }
        .table-responsive {
          border-radius: 0.375rem;
        }
        .ad-preview-container {
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #f0f0f0;
        }
      `}</style>
    </div>
  );
};

export default AdsManagement;
